import { render } from "./BranchList.vue?vue&type=template&id=25bb3488"
import script from "./BranchList.vue?vue&type=script&lang=js"
export * from "./BranchList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__